import { render, staticRenderFns } from "./c_foot.vue?vue&type=template&id=03cda0bb&scoped=true"
import script from "./c_foot.vue?vue&type=script&lang=js"
export * from "./c_foot.vue?vue&type=script&lang=js"
import style0 from "./c_foot.vue?vue&type=style&index=0&id=03cda0bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cda0bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03cda0bb')) {
      api.createRecord('03cda0bb', component.options)
    } else {
      api.reload('03cda0bb', component.options)
    }
    module.hot.accept("./c_foot.vue?vue&type=template&id=03cda0bb&scoped=true", function () {
      api.rerender('03cda0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_foot.vue"
export default component.exports